module.exports = __webpack_public_path__ + "img/price-updated.361a0051.svg";